<template>
  <div>
    <div class="page-header page-header-settings">
      <div class="page-header-title">
        <slot name="title">
          <div>Fundraise</div>
          <p>Create custom checkouts, impact amounts & more!</p>
        </slot>
      </div>
    </div>
    <div v-if="false" class="page-header-links">
      <router-link :to="{name: 'donationAsks'}"
                   :class="{active: $route.name === 'donationAsks'}">
        Checkouts
      </router-link>
      <router-link :to="{name: 'customFields'}"
                   :class="{active: $route.name === 'customFields'}">
        Custom Fields
      </router-link>
      <router-link :to="{name: 'impactAmounts'}"
                   :class="{active: $route.name === 'impactAmounts'}">
        Impact Amounts
      </router-link>
      <a v-if="activeCharityInfo"
         :href="'/donation-options' | webAppLink(activeCharityInfo)"
         target="_blank">
        Fundraising Hub
      </a>
      <router-link v-if="false"
                   :to="{name: 'giveBack'}"
                   :class="{active: $route.name === 'giveBack'}">
        Give Back
      </router-link>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";

  export default {
    name: 'FundraiseMenu',
    computed: {
      ...mapState({
        activeCharityInfo: state => state.charities.activeCharityInfo,
      }),
    }
  };
</script>
<style lang="scss" scoped>
  .page-header-settings {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .page-header-title {
      margin-left: 30px;
      padding: 0;
    }
  }
  .page-header-links {
    padding-left: 30px;
  }

</style>

